import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from './pages/LandingPage';
import './index.css';
import Insta from './pages/insta';
import FamilyMeals from './pages/familymeals';
import SaralContact from './pages/SaralContact';
import SaralModeration from './pages/SaralModeration';
import SaralTranslate from './pages/SaralTranslate';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/insta" element={<Insta />} />
        <Route path="/familymeals" element={<FamilyMeals />} />
        <Route path="/SaralContact" element={<SaralContact />} />
        <Route path="/SaralModeration" element={<SaralModeration />} />
        <Route path="/SaralTranslate" element={<SaralTranslate />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
